import { Task } from "../types";

export const mergeTaskSnapshot = (
  existing: Task | undefined,
  incoming: Task,
  options?: {
    preserveNonEmptyPickupLines?: boolean;
    incomingPartial?: boolean;
    includesVisitMetrics?: boolean;
  }
): Task => {
  if (!existing) return incoming;
  const shouldKeepExistingPickupLines =
    options?.preserveNonEmptyPickupLines &&
    existing.type === "machine_pickup_inventory" &&
    (existing.pickupLines || []).length > 0 &&
    Array.isArray(incoming.pickupLines) &&
    incoming.pickupLines.length === 0;
  const mergedBase = options?.incomingPartial
    ? {
        ...existing,
        ...Object.fromEntries(
          Object.entries(incoming).filter(([, value]) => value !== undefined)
        ),
      }
    : incoming;
  const shouldKeepCarryForward =
    (existing.commissionCarryForward || []).length > 0 &&
    Array.isArray(incoming.commissionCarryForward) &&
    incoming.commissionCarryForward.length === 0 &&
    incoming.previousOutstandingCommissionCents ===
      existing.previousOutstandingCommissionCents &&
    incoming.commissionPaymentStatus === existing.commissionPaymentStatus;
  return {
    ...mergedBase,
    commissionCarryForward: shouldKeepCarryForward
      ? existing.commissionCarryForward
      : incoming.commissionCarryForward !== undefined
        ? incoming.commissionCarryForward
        : existing.commissionCarryForward,
    pickupLines: shouldKeepExistingPickupLines
      ? existing.pickupLines
      : incoming.pickupLines !== undefined
      ? incoming.pickupLines
      : existing.pickupLines,
    assets: incoming.assets !== undefined ? incoming.assets : existing.assets,
    inventoryCompletion:
      incoming.inventoryCompletion !== undefined
        ? incoming.inventoryCompletion
        : existing.inventoryCompletion,
    lastVisitAt: options?.includesVisitMetrics
      ? incoming.lastVisitAt ?? null
      : existing.lastVisitAt ?? incoming.lastVisitAt,
    daysSinceLastVisit: options?.includesVisitMetrics
      ? incoming.daysSinceLastVisit ?? null
      : existing.daysSinceLastVisit ?? incoming.daysSinceLastVisit,
    manualScheduleOverrideAt:
      incoming.manualScheduleOverrideAt !== undefined &&
      incoming.manualScheduleOverrideAt !== null
        ? incoming.manualScheduleOverrideAt
        : existing.manualScheduleOverrideAt,
    manualScheduleOverrideBy:
      incoming.manualScheduleOverrideBy !== undefined &&
      incoming.manualScheduleOverrideBy !== null
        ? incoming.manualScheduleOverrideBy
        : existing.manualScheduleOverrideBy,
    manualScheduleOverrideByName:
      incoming.manualScheduleOverrideByName !== undefined &&
      incoming.manualScheduleOverrideByName !== null
        ? incoming.manualScheduleOverrideByName
        : existing.manualScheduleOverrideByName,
    manualScheduleOverrideByEmail:
      incoming.manualScheduleOverrideByEmail !== undefined &&
      incoming.manualScheduleOverrideByEmail !== null
        ? incoming.manualScheduleOverrideByEmail
        : existing.manualScheduleOverrideByEmail,
    manualScheduleOverrideFrom:
      incoming.manualScheduleOverrideFrom !== undefined &&
      incoming.manualScheduleOverrideFrom !== null
        ? incoming.manualScheduleOverrideFrom
        : existing.manualScheduleOverrideFrom,
    manualScheduleOverrideSource:
      incoming.manualScheduleOverrideSource !== undefined &&
      incoming.manualScheduleOverrideSource !== null
        ? incoming.manualScheduleOverrideSource
        : existing.manualScheduleOverrideSource,
  };
};
